import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

export class ModeloDatos {
  constructor(public num1: number, public num2: number) {
  }
}

@Component({
  selector: 'search',
  templateUrl: 'search.template.html'
})
export class searchComponent {
  context: ModeloDatos;
  public nocompletado: boolean;

  constructor(public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig) {
    console.log('dentro del componente');

    this.context = dialogConfig['context'];
    this.nocompletado = true;
    /* if (this.context) {
       this.selectedObject = this.context.organizationalUnit;
     }*/

    this.nocompletado = true;

  }

  onKeyUp(value) {
    console.log('onKeyUp');
    console.log(value);
    this.nocompletado = value != 'hola';
    this.ref.close();
  }

  onSubmit(value) { }

  beforeDismiss(): boolean {
    console.log('beforeDismiss');
    return true;
  }

  beforeClose(): boolean {
    console.log('beforeClose ' + this.nocompletado);
    return this.nocompletado;
  }
}
